import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectUser } from '@/slice/user';
import { UserRole } from '@/types';
import { ROUTES } from '@/types/routes';

// TCX-668: the old standalone Terms & Conditions page was hard-coded and no
// longer reflects what admins publish. The audience-specific Terms of Use pages
// (/terms-of-use/consultant | /terms-of-use/franchisor) are the canonical,
// dynamically-published source now, so this legacy route just redirects there.
// Role-aware when known (in-app SPA navigation); on a cold direct hit the store
// is empty, so it falls back to the consultant copy.
export function TermsAndConditions() {
  const { role } = useAppSelector(selectUser);
  const target =
    role === UserRole.FRANCHISEE
      ? ROUTES.TERMS_OF_USE_FRANCHISOR
      : ROUTES.TERMS_OF_USE_CONSULTANT;

  return <Navigate to={target} replace />;
}
